// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'
import { sync } from 'vuex-router-sync'

import App from './App'
import router from './router'
import store from '@/store'
import '@/filters/index'

import vuetify from '@/plugins/vuetify'

// Sincronizar store com router
sync(store, router)

Vue.prototype.$loading = false

Vue.config.productionTip = true
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js